import React from 'react';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import {
  commonPCConsoleDefaultFilterValue,
  handleDetailGSDFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
import PCUPhysicalDigital from '../index';
import {
  getDetailPageCfg,
  DETAIL_PAGEID,
} from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import {
  statsGSDTrend,
  statsCountriesTrend,
  statsCountriesTable,
} from '@/pages/intelligence/services/topcharts';

export default function GSDData(props: any) {
  const {
    entityType,
    gameId,
    pageId,
    tabType,
    gsdDevicesFlatten,
    gsdOptionsLoading,
    gsdDeviceOptions,
    gsdDeviceCascaderOptions,
    gsdSegmentOptions,
    gsdSegments,
    downloadModalSize,
    getRadioOptionsTips,
  } = props;

  const { filterLoading: regionLoding, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.gsd,
  });
  const filterLoading = regionLoding || gsdOptionsLoading;
  const deviceDefVales = gsdDeviceOptions?.map((t) => t?.value);
  const segDefVales = gsdSegmentOptions?.map((t) => t?.value)?.[0];

  const defaultFilterValue = {
    ...commonPCConsoleDefaultFilterValue,
    [filterKeyMap.REGION]: {
      // regions: ['na'],
      regions: [],
      markets: ['global'],
      type: 'region',
    },
    [filterKeyMap.GSD_DEVICE]: {
      value: deviceDefVales,
    },
    [filterKeyMap.GSD_SEGEMENT]: {
      value: segDefVales,
    },
    [filterKeyMap.RANGE_TIME]: {
      type: 'week',
      value: ['', ''],
    },
    [filterKeyMap.PUBLISHER]: {
      value: 'NETWORK',
    },
  };
  const hasDevice = entityType === 'console' || entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE;

  const filterKeyList = [filterKeyMap.RANGE_TIME, filterKeyMap.REGION, filterKeyMap.GSD_SEGEMENT];
  if (hasDevice) {
    filterKeyList.push(filterKeyMap.GSD_DEVICE);
  }
  filterKeyList.push(filterKeyMap.PUBLISHER);
  const filterCfg = {
    filterKeyList,
    regionFilterParams: {},
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    specialParams: {
      regionOptions, // 国家筛选器options,
      getRadioOptionsTips,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.rangeWeek,
      // disableIegg: false,
      // disableAnnie: true,
      isShowAlloftime: false,
      showShortcut: true,
      gsdDeviceOptions: gsdDeviceOptions || [],
      [filterKeyMap.GSD_DEVICE]: {
        useCascaderStyle: true,
        cascaderHierarchicalOptions: gsdDeviceCascaderOptions || [],
      },
      gsdSegmentOptions: gsdSegmentOptions || [],
      entityType,
      showRadioBubble: true,
    },
    showConfirmButton: false,
    haveFilterSaveBtn: false,
    handleFilterToApiParams: handleDetailGSDFilterParamsToApi,
  };

  const pageCfg = getDetailPageCfg(pageId, tabType, entityType);
  const defaultByDeviceVal = pageCfg?.defaultByDeviceVal || undefined;
  const params = {
    source: 'gsd',
    tab_name: 'gsd_digitalRevenue',
    regions: ['global'],
    segment: segDefVales,
    sort_field: 'gsd_digitalUnits',
    unified_id: gameId,
    entity_type: entityType,
    region_type: 'market',
    start_date: '',
    end_date: '',
    date_type: 'weekly',
    sort_type: 'desc',
    device: hasDevice ? deviceDefVales : undefined,
    b_group_by_device: defaultByDeviceVal,
    metric: ['gsd_digitalRevenue'],
    gsd_types: ['NETWORK'],
  };

  return !filterLoading ? (
    <PCUPhysicalDigital
      {...props}
      // entityType={'console'}
      // pageId={pageId}
      // pageLogInfo={dbiPageLogMes.topChartsConsoleGamesDigitalRevenue}
      // tableCloumsList={digitalRevenueList}
      // hasRegionFilter={true}
      // cardMetricName={formatMessage({ id: 'dbi_digital_revenue' })}
      downloadModalSize={downloadModalSize}
      filterCfg={filterCfg}
      filterLoading={filterLoading}
      // rangeTimeComponentDefault={latestTimeTypeHasData}
      pageCfg={pageCfg}
      pageParameters={params}
      releaseInFortyDay={false} // GSD这里因为是周粒度，所以这里配置为false不让它为日粒度
      metricKey={DETAIL_PAGEID.gsd}
      regionsCountries={regionOptions} // GSD用自己的筛选器的数据来匹配中英文
      getTrendsFun={statsGSDTrend}
      getMarketTrendsFun={statsCountriesTrend}
      getMarketTableFun={statsCountriesTable}
      gsdDevicesFlatten={gsdDevicesFlatten}
      gsdSegments={gsdSegments}
    />
  ) : null;
}
